module.exports = __webpack_public_path__ + "img/logoOne.a05f4e64.png";